<template>
  <div class="local-patient-list">
    <project-list-items
      :projects="projects"
      :selected-projects="selectedProjects"
      remote-list
    />

    <v-snackbar
      v-model="showSnackbar"
      :color="colorSnackbar"
      :timeout="2000"
      top
    >
      {{ textSnackbar }}
      <v-btn
        text
        @click="showSnackbar = false"
      >
        Fermer
      </v-btn>
    </v-snackbar>

    <div class="save-container">
      <v-btn
        class="save"
        @click="synchronizeSelectedProjects(selectedProjects)"
      >
        Synchronisation
      </v-btn>
      <v-btn
        class="save"
        disabled
        @click="getAllProjects(projectsUuidArray)"
      >
        Tout synchroniser
      </v-btn>
      <v-btn
        class="save"
        @click="$router.push({ name: 'LocalPatientList' })"
      >
        Base Tablette
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

import { synchronization } from "@/mixins/synchronization.js";

import ProjectListItems from "../components/ProjectListItems";

export default {
  name: "RemotePatientList",
  components: {
    ProjectListItems
  },
  mixins: [synchronization],
  data() {
    return {
      selectedProjects: [],

      // Show snackbar
      showSnackbar: false,
      textSnackbar: "",
      colorSnackbar: "success"
    };
  },
  computed: {
    ...mapState({
      projects: state => state.projects.projects
    }),

    ...mapGetters({
      isLoggedIn: "auth/isLoggedIn",
      getPatientByUuid: "patients/getByUuid"
    }),

    projectsUuidArray() {
      return this.projects.map(project => {
        return project.uuid;
      });
    }
  },

  mounted() {
    this.load();
    this.getProjectsFromIndexedDB();
  },

  methods: {
    ...mapActions({
      logout: "auth/logout",
      getProjects: "projects/getProjects",
      getPatients: "patients/getPatients",
      getProject: "projects/getProject",
      getPatient: "patients/getPatient"
    }),

    // If user is connected, and not offline fetch al projects
    async load() {
      // If not logged in return to LoginPage
      if (!this.isLoggedIn) {
        await this.logout();
        this.$router.push({ name: "LoginPage" });
        return;
      }

      // Get projects
      await this.getProjects();
      await this.getPatients();
    },

    // Get IndexedDB projects
    async getProjectsFromIndexedDB() {
      return await this.$db.projects.each(project => {
        this.selectedProjects.push(project.uuid);
      });
    },

    // Sync selected projects with IndexedDB
    async synchronizeSelectedProjects(selectedProjects) {
      try {
        await this.synchronizeProjects(selectedProjects);

        this.textSnackbar = "Synchronisation réalisée avec succès";
        this.colorSnackbar = "success";
        this.showSnackbar = true;
      } catch (error) {
        console.error(error.response.data);

        this.textSnackbar =
          "Un probléme est survenue lors de la synchronisation.";
        this.colorSnackbar = "error";
        this.showSnackbar = true;
      }
    },

    // Sync selected projects with IndexedDB
    async getAllProjects(selectedProjects) {
      try {
        await this.synchronizeAllProjects(selectedProjects);

        this.textSnackbar = "Synchronisation réalisée avec succès";
        this.colorSnackbar = "success";
        this.showSnackbar = true;
      } catch (error) {
        this.textSnackbar =
          "Un probléme est survenue lors de la synchronisation.";
        this.colorSnackbar = "error";
        this.showSnackbar = true;
      }
    }
  }
};
</script>

<style lang="scss"></style>
